import React from "react";
import { Link } from "react-router-dom";
import "./WelcomeTo.css";

function WelcomeTo() {
  return (
    <section className="band welcome-section" id="about">
      <div className="wrap">
        <div className="welcome-layout-grid">
          {/* Left: Complete SEO Content & Highlights */}
          <div className="welcome-content-col">
            <p className="eyebrow">About the centre</p>
            <h2 className="h-sec">Welcome to Lakshmi Maternity &amp; Surgical Centre!</h2>
            
            <div className="welcome-prose">
              <p className="welcome-lead">
                <strong>Experience exceptional care at Lakshmi Maternity &amp; Surgical Centre, where your well-being is our top priority.</strong> With over <strong>33 years of cumulative experience</strong>, our highly experienced doctors, including <strong>Dr. Mahesh Rao</strong>, and <strong>Dr. Nishita Rao</strong>, are dedicated to providing the best healthcare services in <strong>women's health, maternity care, and surgical procedures</strong>.
              </p>
              
              <p>
                As the <strong>best maternity hospital in Bangalore for normal delivery</strong>, we are proud to have a remarkable track record of <strong>90% normal deliveries</strong>, ensuring a <strong>natural childbirth experience</strong> that is safe and supported every step of the way. Our team of <strong>experienced obstetricians</strong> specializes in providing expert care to help you achieve a <strong>safe delivery</strong>, and our <strong>natural childbirth specialists</strong> ensure that both mother and baby are taken care of throughout the process.
              </p>

              {/* Key Trust Highlights Matrix */}
              <div className="welcome-stats-matrix">
                <div className="welcome-stat-box">
                  <span className="w-stat-num">90%</span>
                  <span className="w-stat-lbl">Normal Delivery Rate</span>
                </div>
                <div className="welcome-stat-box">
                  <span className="w-stat-num">1,05,000+</span>
                  <span className="w-stat-lbl">Healthy Babies Delivered</span>
                </div>
                <div className="welcome-stat-box">
                  <span className="w-stat-num">33+ Yrs</span>
                  <span className="w-stat-lbl">Cumulative Experience</span>
                </div>
                <div className="welcome-stat-box">
                  <span className="w-stat-num">24/7</span>
                  <span className="w-stat-lbl">Labor &amp; Delivery Support</span>
                </div>
              </div>
              
              <p>
                At <strong>Lakshmi Maternity &amp; Surgical Centre</strong>, we understand that mother and baby care is of utmost importance, which is why we offer <strong>24/7 labor and delivery support</strong> and affordable maternity care, ensuring that you feel supported and comfortable during this special time.
              </p>
              
              <p>
                Our <strong>state-of-the-art facilities</strong> are equipped with the latest <strong>world-class technology</strong>, providing <strong>accurate diagnoses and effective treatments</strong>. From routine check-ups to more complex procedures, we offer a comprehensive range of services, with a special focus on personalized attention for each patient's needs.
              </p>
              
              <p>
                <strong>Lakshmi Maternity &amp; Surgical Centre</strong> is a trusted name in <strong>maternity care in Bangalore</strong>, having delivered over <strong>105,000 healthy babies</strong> since 2011. Founded by <strong>Dr. Leela Rao</strong>, we strive to provide the best care possible with a <strong>feel-like-home atmosphere</strong>.
              </p>
              
              <p>
                We are a safe delivery hospital with a warm, welcoming environment, where you and your baby's health are our top priority. <Link to="/appointment" className="welcome-consult-link">Book your consultation today</Link> and experience exceptional care with a hospital dedicated to making your birth experience as smooth and healthy as possible.
              </p>
              
              <p>
                Your health and happiness matter to us, and we are here to support you every step of the way at Lakshmi Maternity &amp; Surgical Centre.
              </p>
            </div>

            <div className="welcome-actions">
              <Link className="btn-solid" to="/appointment">
                Book an Appointment
              </Link>
              <Link className="btn-ghost" to="/about">
                Learn more about us &rarr;
              </Link>
            </div>
          </div>

          {/* Right: Sticky Image & Hospital Trust Card */}
          <aside className="welcome-media-col">
            <div className="welcome-sticky-card">
              <figure className="welcome-fig">
                <img
                  src="/img/welcometo.webp"
                  alt="Welcome to Lakshmi Maternity and Surgical Centre Malleswaram"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/uplaods/General-services.webp";
                  }}
                />
              </figure>
              
              <div className="welcome-trust-badge">
                <div className="w-badge-header">
                  <span className="w-badge-pill">Malleswaram, Bangalore</span>
                  <span className="w-badge-rating">★ 4.8 / 5.0</span>
                </div>
                <h4 className="w-badge-title">Lakshmi Maternity &amp; Surgical Centre</h4>
                <p className="w-badge-desc">
                  Founded by <strong>Dr. Leela Rao</strong> &middot; Led by <strong>Dr. Mahesh Rao</strong> &amp; <strong>Dr. Nishita Rao</strong>
                </p>
                <div className="w-badge-points">
                  <div className="w-point">✓ 24/7 Obstetric &amp; Labor Care</div>
                  <div className="w-point">✓ Experienced Natural Delivery Team</div>
                  <div className="w-point">✓ In-House Diagnostic &amp; Surgical Facility</div>
                </div>
                <div className="w-badge-cta">
                  <Link to="/appointment" className="btn-solid btn-sm">
                    Book Consultation
                  </Link>
                  <a href="tel:08023347276" className="btn-ghost btn-sm">
                    Call 080 2334 7276
                  </a>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default WelcomeTo;
